/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_3Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_4_steps_3 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only then try a copy of your own file. Keep a list of missing features or differences that matter to your actual task.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_4_steps_3 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`然后再尝试你自己的文件副本，记录会影响实际任务的功能缺失或差异。`)
};

/**
* | output |
* | --- |
* | "Only then try a copy of your own file. Keep a list of missing features or differences that matter to your actual task." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_4_steps_3 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_4_steps_3(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_4_steps_3(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_4_steps_3 as "gc.search_guides.what_is_gridcraft.sections.4.steps.3" }